import { render } from "./MDBIcon.vue?vue&type=template&id=66378c7e"
import script from "./MDBIcon.vue?vue&type=script&lang=js"
export * from "./MDBIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/mdb/projects/mdb5-repos/vue/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__